import React from 'react';
import Swal from 'sweetalert2';
import api from '../../Services/ApiService';
import { Button } from './styles';


// import { Container } from './styles';
const cancelarAgendamento = async (chave: string) => {
  try {
    await api.delete(`/agendamentos/cancelaragendamento/${chave}`);
    Swal.fire({
      title:'Sucesso!',
      text:'Seu agendamento foi cancelado com sucesso!',
      icon: 'success'
    })
  } catch (error:any) {
    return Swal.fire({
      title:'Erro!',
      text:`${error.response.data}`,
      icon: 'error'
    })
  }
}
const showCancelarAgendamentoAlert = async () => { 
  Swal.fire({
    title: 'Cancelar Agendamento',
    input:'text',
    inputLabel:'Chave de cancelamento',
    inputPlaceholder:'Insira sua chave de cancelamento',
    inputAutoTrim: true, 
    footer:'<small style="font-size:0.8rem">A chave pode ser encontrada no e-mail de confirmação de agendamento</small>',
    showCancelButton: true,
    cancelButtonText: 'Fechar',
    confirmButtonText: 'Realizar cancelamento',
    confirmButtonColor: '#ff0000',
    showLoaderOnConfirm: true,
    preConfirm: (chave) => {
      return cancelarAgendamento(chave);
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    if (result.isConfirmed) {
      Swal.fire({
        icon: 'success',
        title: `Agendamento cancelado com sucesso`,
      })
    }
  });
}

const CancelarAgendamento: React.FC = () => {
  return <Button onClick={showCancelarAgendamentoAlert}>Cancelar Agendamento</Button>;
}

export default CancelarAgendamento;